<template>
  <div class="BucketNavigation">
    <Btn
      class="ib light"
      :disabled="bucket.laptops.length <= bucketResizeStep"
      icon="up"
      :isLoading="isLoading"
      @click="$emit('offset', -bucketResizeStep)">
      {{ $t('less') }}
    </Btn>
    <Btn
      class="ib light"
      :disabled="bucket.total === bucket.laptops.length"
      icon="down"
      :isLoading="isLoading"
      @click="$emit('offset', bucketResizeStep)">
      {{ $t('more') }}
    </Btn>
  </div>
</template>

<script>
export default {
  props: {
    bucket: { type: Object, required: true },
    bucketResizeStep: { type: Number, required: true },
    isLoading: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss">
.BucketNavigation {
  margin-bottom: $grid-unit;
  text-align: right;

  .Btn {
    margin-left: $u;
  }
}
</style>

<i18n>
{
  "en": {
    "less": "Show less",
    "more": "Show more"
  }
}
</i18n>
